import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditEspectaculosComponent } from "./edit-espectaculos/edit-espectaculos.component";

@Component({
  selector: "app-espectaculos",
  templateUrl: "./espectaculos.component.html",
  styleUrls: ["./espectaculos.component.scss"],
})
export class EspectaculosComponent extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }
  
  openPanel() {
    this.customanpanel = EditEspectaculosComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
